import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

export function VedaPurchaseOrderGuard({ children }: { children: ReactNode }) {
  const user = useAuthStore(s => s.user);
  if (!user) return null;
  if (['sales_rep', 'sales_manager'].includes(user.role?.name?.toLowerCase() ?? '')) {
    return <Navigate to="/veda-agro/orders?type=so" replace />;
  }
  return <>{children}</>;
}
